import { render, staticRenderFns } from "./loader.vue?vue&type=template&id=d46ba308&"
var script = {}
import style0 from "./loader.vue?vue&type=style&index=0&id=d46ba308&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports